import { useContext } from 'react';
import SidebarContext from 'common/contexts/SidebarContext';

export default function useSidebarContext() {
  return useContext(SidebarContext);
}
